export const eventTypeColors = {
    "bollywood dj night": "linear-gradient(95.58deg, #F97A33 12.18%, #E3BD36 86.93%)",
    "bollywood nights": "linear-gradient(95.58deg, #F97A33 12.18%, #E3BD36 86.93%)",
    "dj night": "linear-gradient(95.58deg, #F97A33 12.18%, #E3BD36 86.93%)",
    "comedy night": "linear-gradient(95.58deg, #338EF9 12.18%, #36D9E3 86.93%)",
    "live music": "linear-gradient(95.58deg, #73BF9B 12.18%, #4B6CB7 86.93%)",
    "ladies dj night": "linear-gradient(95.58deg, #73BF9B 12.18%, #4B6CB7 86.93%)",
    "quiz night": "linear-gradient(95.58deg, #134E5E 12.18%, #71B280 86.93%)",
    "special occasion": "linear-gradient(95.58deg, #F97A33 12.18%, #E3BD36 86.93%)",
    "open mic night": "linear-gradient(95.58deg, #8CA6DB 12.18%, #B993D6 86.93%)",
    "karaoke night": "linear-gradient(95.58deg, #649173 12.18%, #DBD5A4 86.93%)",
    "sports screening": "linear-gradient(95.58deg, #1D2B64 12.18%, #F8CDDA 86.93%)",
    "holi party": "linear-gradient(90.95deg, #F9A503 3.11%, #73B3FF 34.63%, #FF8787 64.66%, rgba(255, 20, 109, 0.75) 99.18%)",
};
export const tablePerksIcons = {
    "Private Waiter": "/icons/private-waiter.svg",
    "Valet Parking": "/icons/valet-parking.svg",
    "Party Guns": "/icons/party-guns.svg",
    "Bottle Service": "/icons/bottle-service.svg",
    "Customized Lighting": "/icons/customized-lighting.svg",
    "Exclusive Lounge Access": "/icons/exclusive-lounge.svg",
    "Personal DJ Shoutouts": "/icons/dj-shoutouts.svg",
    "Complimentary Champagne": "/icons/complimentary-champagne.svg",
    "Special Table Décor": "/icons/special-decor.svg",
    "Photo Booth Access": "/icons/photo-booth.svg",
    "Priority Entry": "/icons/priority-entry.svg",
    "VIP Wristbands": "/icons/vip-wristbands.svg",
    "Appetizer Platter": "/icons/appetizer-platter.svg",
    "Personalized Cake": "/icons/personalized-cake.svg",
    "Private Security": "/icons/private-security.svg",
    "Hookah Service": "/icons/hookah-service.svg",
    "Reserved Parking Spot": "/icons/reserved-parking.svg",
    "Table-side Mixologist": "/icons/mixologist.svg",
    "Customized Drink Menu": "/icons/custom-drink-menu.svg",
    "Private Dance Floor Access": "/icons/dance-floor.svg",
};
export const menuTypeTheme = {
    bbq: {
        primary: "#E86500",
        theme: "dark",
    },
    floral: {
        primary: "#4B678A",
        secondary: "#F3F6EE",
        theme: "light",
    },
    beach: {
        primary: "#00E8C9",
        theme: "dark",
    },
    rooftop: {
        primary: "#967d45",
        theme: "dark",
    },
    nonvegthali: {
        primary: "#7A0000",
        secondary: "#F2E4C9",
        theme: "light",
    },
    vegthali: {
        primary: "#7A0000",
        secondary: "#F2E4C9",
        theme: "light",
    },
    blossom: {
        primary: "#C05D71",
        theme: "light",
    },
    classic_light: {
        primary: "#0C5D56",
        theme: "light",
    },
    classic_dark: {
        primary: "#A6763B",
        theme: "dark",
    },
    finedine_normal: {
        primary: "#E86500",
        theme: "dark",
    },
    finedine_premium: {
        primary: "#E86500",
        theme: "dark",
    },
    cafe_normal: {
        primary: "#B9774C",
        secondary: "#F1E7D7",
        theme: "light",
    },
    cafe_premium: {
        primary: "#B9774C",
        theme: "dark",
    },
};
export const categoryLabel = {
    chefRecommend: "Chef's Recommended",
    specialItems: "Today's Special",
};
export const ThemisFoodCourtPubs = {
    600: {
        name: "Themis Greek House Murthal",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/600.png",
    },
    623: {
        name: "Themis Greek House BYOB",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/623.jpeg",
    },
    663: {
        name: "Athens Pizza",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/663.jpeg",
    },
    664: {
        name: "Dosa Plaza",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/664.jpeg",
    },
    665: {
        name: "Barista",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/665.jpeg",
    },
    666: {
        name: "Themis Street Food",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/666.png",
    },
};
export const VenueCountryCode = {
    "708": "1",
};
export const countryOptions = [
    { value: "91", label: "+91 (India)", countryCode: "IN", name: "India" },
    { value: "93", label: "+93 (Afghanistan)", countryCode: "AF", name: "Afghanistan" },
    { value: "355", label: "+355 (Albania)", countryCode: "AL", name: "Albania" },
    { value: "213", label: "+213 (Algeria)", countryCode: "DZ", name: "Algeria" },
    { value: "376", label: "+376 (Andorra)", countryCode: "AD", name: "Andorra" },
    { value: "244", label: "+244 (Angola)", countryCode: "AO", name: "Angola" },
    { value: "1-268", label: "+1-268 (Antigua and Barbuda)", countryCode: "AG", name: "Antigua and Barbuda" },
    { value: "54", label: "+54 (Argentina)", countryCode: "AR", name: "Argentina" },
    { value: "374", label: "+374 (Armenia)", countryCode: "AM", name: "Armenia" },
    { value: "297", label: "+297 (Aruba)", countryCode: "AW", name: "Aruba" },
    { value: "61", label: "+61 (Australia)", countryCode: "AU", name: "Australia" },
    { value: "43", label: "+43 (Austria)", countryCode: "AT", name: "Austria" },
    { value: "994", label: "+994 (Azerbaijan)", countryCode: "AZ", name: "Azerbaijan" },
    { value: "1-242", label: "+1-242 (Bahamas)", countryCode: "BS", name: "Bahamas" },
    { value: "973", label: "+973 (Bahrain)", countryCode: "BH", name: "Bahrain" },
    { value: "880", label: "+880 (Bangladesh)", countryCode: "BD", name: "Bangladesh" },
    { value: "1-246", label: "+1-246 (Barbados)", countryCode: "BB", name: "Barbados" },
    { value: "375", label: "+375 (Belarus)", countryCode: "BY", name: "Belarus" },
    { value: "32", label: "+32 (Belgium)", countryCode: "BE", name: "Belgium" },
    { value: "501", label: "+501 (Belize)", countryCode: "BZ", name: "Belize" },
    { value: "229", label: "+229 (Benin)", countryCode: "BJ", name: "Benin" },
    { value: "975", label: "+975 (Bhutan)", countryCode: "BT", name: "Bhutan" },
    { value: "591", label: "+591 (Bolivia)", countryCode: "BO", name: "Bolivia" },
    { value: "387", label: "+387 (Bosnia and Herzegovina)", countryCode: "BA", name: "Bosnia and Herzegovina" },
    { value: "267", label: "+267 (Botswana)", countryCode: "BW", name: "Botswana" },
    { value: "55", label: "+55 (Brazil)", countryCode: "BR", name: "Brazil" },
    { value: "673", label: "+673 (Brunei)", countryCode: "BN", name: "Brunei" },
    { value: "359", label: "+359 (Bulgaria)", countryCode: "BG", name: "Bulgaria" },
    { value: "226", label: "+226 (Burkina Faso)", countryCode: "BF", name: "Burkina Faso" },
    { value: "257", label: "+257 (Burundi)", countryCode: "BI", name: "Burundi" },
    { value: "855", label: "+855 (Cambodia)", countryCode: "KH", name: "Cambodia" },
    { value: "237", label: "+237 (Cameroon)", countryCode: "CM", name: "Cameroon" },
    { value: "1", label: "+1 (Canada)", countryCode: "CA", name: "Canada" },
    { value: "238", label: "+238 (Cape Verde)", countryCode: "CV", name: "Cape Verde" },
    { value: "236", label: "+236 (Central African Republic)", countryCode: "CF", name: "Central African Republic" },
    { value: "235", label: "+235 (Chad)", countryCode: "TD", name: "Chad" },
    { value: "56", label: "+56 (Chile)", countryCode: "CL", name: "Chile" },
    { value: "86", label: "+86 (China)", countryCode: "CN", name: "China" },
    { value: "57", label: "+57 (Colombia)", countryCode: "CO", name: "Colombia" },
    { value: "269", label: "+269 (Comoros)", countryCode: "KM", name: "Comoros" },
    { value: "682", label: "+682 (Cook Islands)", countryCode: "CK", name: "Cook Islands" },
    { value: "506", label: "+506 (Costa Rica)", countryCode: "CR", name: "Costa Rica" },
    { value: "385", label: "+385 (Croatia)", countryCode: "HR", name: "Croatia" },
    { value: "53", label: "+53 (Cuba)", countryCode: "CU", name: "Cuba" },
    { value: "357", label: "+357 (Cyprus)", countryCode: "CY", name: "Cyprus" },
    { value: "420", label: "+420 (Czech Republic)", countryCode: "CZ", name: "Czech Republic" },
    { value: "45", label: "+45 (Denmark)", countryCode: "DK", name: "Denmark" },
    { value: "253", label: "+253 (Djibouti)", countryCode: "DJ", name: "Djibouti" },
    { value: "1-767", label: "+1-767 (Dominica)", countryCode: "DM", name: "Dominica" },
    { value: "1-809", label: "+1-809 (Dominican Republic)", countryCode: "DO", name: "Dominican Republic" },
    { value: "593", label: "+593 (Ecuador)", countryCode: "EC", name: "Ecuador" },
    { value: "20", label: "+20 (Egypt)", countryCode: "EG", name: "Egypt" },
    { value: "503", label: "+503 (El Salvador)", countryCode: "SV", name: "El Salvador" },
    { value: "240", label: "+240 (Equatorial Guinea)", countryCode: "GQ", name: "Equatorial Guinea" },
    { value: "291", label: "+291 (Eritrea)", countryCode: "ER", name: "Eritrea" },
    { value: "372", label: "+372 (Estonia)", countryCode: "EE", name: "Estonia" },
    { value: "268", label: "+268 (Eswatini)", countryCode: "SZ", name: "Eswatini" },
    { value: "251", label: "+251 (Ethiopia)", countryCode: "ET", name: "Ethiopia" },
    { value: "679", label: "+679 (Fiji)", countryCode: "FJ", name: "Fiji" },
    { value: "358", label: "+358 (Finland)", countryCode: "FI", name: "Finland" },
    { value: "33", label: "+33 (France)", countryCode: "FR", name: "France" },
    { value: "241", label: "+241 (Gabon)", countryCode: "GA", name: "Gabon" },
    { value: "220", label: "+220 (Gambia)", countryCode: "GM", name: "Gambia" },
    { value: "995", label: "+995 (Georgia)", countryCode: "GE", name: "Georgia" },
    { value: "49", label: "+49 (Germany)", countryCode: "DE", name: "Germany" },
    { value: "233", label: "+233 (Ghana)", countryCode: "GH", name: "Ghana" },
    { value: "30", label: "+30 (Greece)", countryCode: "GR", name: "Greece" },
    { value: "299", label: "+299 (Greenland)", countryCode: "GL", name: "Greenland" },
    { value: "1-473", label: "+1-473 (Grenada)", countryCode: "GD", name: "Grenada" },
    { value: "502", label: "+502 (Guatemala)", countryCode: "GT", name: "Guatemala" },
    { value: "224", label: "+224 (Guinea)", countryCode: "GN", name: "Guinea" },
    { value: "245", label: "+245 (Guinea-Bissau)", countryCode: "GW", name: "Guinea-Bissau" },
    { value: "592", label: "+592 (Guyana)", countryCode: "GY", name: "Guyana" },
    { value: "509", label: "+509 (Haiti)", countryCode: "HT", name: "Haiti" },
    { value: "504", label: "+504 (Honduras)", countryCode: "HN", name: "Honduras" },
    { value: "852", label: "+852 (Hong Kong)", countryCode: "HK", name: "Hong Kong" },
    { value: "36", label: "+36 (Hungary)", countryCode: "HU", name: "Hungary" },
    { value: "354", label: "+354 (Iceland)", countryCode: "IS", name: "Iceland" },
    { value: "62", label: "+62 (Indonesia)", countryCode: "ID", name: "Indonesia" },
    { value: "98", label: "+98 (Iran)", countryCode: "IR", name: "Iran" },
    { value: "964", label: "+964 (Iraq)", countryCode: "IQ", name: "Iraq" },
    { value: "353", label: "+353 (Ireland)", countryCode: "IE", name: "Ireland" },
    { value: "972", label: "+972 (Israel)", countryCode: "IL", name: "Israel" },
    { value: "39", label: "+39 (Italy)", countryCode: "IT", name: "Italy" },
    { value: "1-876", label: "+1-876 (Jamaica)", countryCode: "JM", name: "Jamaica" },
    { value: "81", label: "+81 (Japan)", countryCode: "JP", name: "Japan" },
    { value: "962", label: "+962 (Jordan)", countryCode: "JO", name: "Jordan" },
    { value: "254", label: "+254 (Kenya)", countryCode: "KE", name: "Kenya" },
    { value: "686", label: "+686 (Kiribati)", countryCode: "KI", name: "Kiribati" },
    { value: "850", label: "+850 (North Korea)", countryCode: "KP", name: "North Korea" },
    { value: "82", label: "+82 (South Korea)", countryCode: "KR", name: "South Korea" },
    { value: "965", label: "+965 (Kuwait)", countryCode: "KW", name: "Kuwait" },
    { value: "996", label: "+996 (Kyrgyzstan)", countryCode: "KG", name: "Kyrgyzstan" },
    { value: "856", label: "+856 (Laos)", countryCode: "LA", name: "Laos" },
    { value: "371", label: "+371 (Latvia)", countryCode: "LV", name: "Latvia" },
    { value: "961", label: "+961 (Lebanon)", countryCode: "LB", name: "Lebanon" },
    { value: "266", label: "+266 (Lesotho)", countryCode: "LS", name: "Lesotho" },
    { value: "231", label: "+231 (Liberia)", countryCode: "LR", name: "Liberia" },
    { value: "218", label: "+218 (Libya)", countryCode: "LY", name: "Libya" },
    { value: "423", label: "+423 (Liechtenstein)", countryCode: "LI", name: "Liechtenstein" },
    { value: "370", label: "+370 (Lithuania)", countryCode: "LT", name: "Lithuania" },
    { value: "352", label: "+352 (Luxembourg)", countryCode: "LU", name: "Luxembourg" },
    { value: "853", label: "+853 (Macao)", countryCode: "MO", name: "Macao" },
    { value: "389", label: "+389 (North Macedonia)", countryCode: "MK", name: "North Macedonia" },
    { value: "261", label: "+261 (Madagascar)", countryCode: "MG", name: "Madagascar" },
    { value: "265", label: "+265 (Malawi)", countryCode: "MW", name: "Malawi" },
    { value: "60", label: "+60 (Malaysia)", countryCode: "MY", name: "Malaysia" },
    { value: "960", label: "+960 (Maldives)", countryCode: "MV", name: "Maldives" },
    { value: "223", label: "+223 (Mali)", countryCode: "ML", name: "Mali" },
    { value: "356", label: "+356 (Malta)", countryCode: "MT", name: "Malta" },
    { value: "692", label: "+692 (Marshall Islands)", countryCode: "MH", name: "Marshall Islands" },
    { value: "222", label: "+222 (Mauritania)", countryCode: "MR", name: "Mauritania" },
    { value: "230", label: "+230 (Mauritius)", countryCode: "MU", name: "Mauritius" },
    { value: "52", label: "+52 (Mexico)", countryCode: "MX", name: "Mexico" },
    { value: "691", label: "+691 (Micronesia)", countryCode: "FM", name: "Micronesia" },
    { value: "373", label: "+373 (Moldova)", countryCode: "MD", name: "Moldova" },
    { value: "377", label: "+377 (Monaco)", countryCode: "MC", name: "Monaco" },
    { value: "976", label: "+976 (Mongolia)", countryCode: "MN", name: "Mongolia" },
    { value: "382", label: "+382 (Montenegro)", countryCode: "ME", name: "Montenegro" },
    { value: "212", label: "+212 (Morocco)", countryCode: "MA", name: "Morocco" },
    { value: "258", label: "+258 (Mozambique)", countryCode: "MZ", name: "Mozambique" },
    { value: "95", label: "+95 (Myanmar)", countryCode: "MM", name: "Myanmar" },
    { value: "264", label: "+264 (Namibia)", countryCode: "NA", name: "Namibia" },
    { value: "674", label: "+674 (Nauru)", countryCode: "NR", name: "Nauru" },
    { value: "977", label: "+977 (Nepal)", countryCode: "NP", name: "Nepal" },
    { value: "31", label: "+31 (Netherlands)", countryCode: "NL", name: "Netherlands" },
    { value: "64", label: "+64 (New Zealand)", countryCode: "NZ", name: "New Zealand" },
    { value: "505", label: "+505 (Nicaragua)", countryCode: "NI", name: "Nicaragua" },
    { value: "227", label: "+227 (Niger)", countryCode: "NE", name: "Niger" },
    { value: "234", label: "+234 (Nigeria)", countryCode: "NG", name: "Nigeria" },
    { value: "47", label: "+47 (Norway)", countryCode: "NO", name: "Norway" },
    { value: "968", label: "+968 (Oman)", countryCode: "OM", name: "Oman" },
    { value: "92", label: "+92 (Pakistan)", countryCode: "PK", name: "Pakistan" },
    { value: "680", label: "+680 (Palau)", countryCode: "PW", name: "Palau" },
    { value: "970", label: "+970 (Palestine)", countryCode: "PS", name: "Palestine" },
    { value: "507", label: "+507 (Panama)", countryCode: "PA", name: "Panama" },
    { value: "675", label: "+675 (Papua New Guinea)", countryCode: "PG", name: "Papua New Guinea" },
    { value: "595", label: "+595 (Paraguay)", countryCode: "PY", name: "Paraguay" },
    { value: "51", label: "+51 (Peru)", countryCode: "PE", name: "Peru" },
    { value: "63", label: "+63 (Philippines)", countryCode: "PH", name: "Philippines" },
    { value: "48", label: "+48 (Poland)", countryCode: "PL", name: "Poland" },
    { value: "351", label: "+351 (Portugal)", countryCode: "PT", name: "Portugal" },
    { value: "974", label: "+974 (Qatar)", countryCode: "QA", name: "Qatar" },
    { value: "40", label: "+40 (Romania)", countryCode: "RO", name: "Romania" },
    { value: "7", label: "+7 (Russia)", countryCode: "RU", name: "Russia" },
    { value: "250", label: "+250 (Rwanda)", countryCode: "RW", name: "Rwanda" },
    { value: "685", label: "+685 (Samoa)", countryCode: "WS", name: "Samoa" },
    { value: "378", label: "+378 (San Marino)", countryCode: "SM", name: "San Marino" },
    { value: "239", label: "+239 (Sao Tome and Principe)", countryCode: "ST", name: "Sao Tome and Principe" },
    { value: "966", label: "+966 (Saudi Arabia)", countryCode: "SA", name: "Saudi Arabia" },
    { value: "221", label: "+221 (Senegal)", countryCode: "SN", name: "Senegal" },
    { value: "381", label: "+381 (Serbia)", countryCode: "RS", name: "Serbia" },
    { value: "248", label: "+248 (Seychelles)", countryCode: "SC", name: "Seychelles" },
    { value: "232", label: "+232 (Sierra Leone)", countryCode: "SL", name: "Sierra Leone" },
    { value: "65", label: "+65 (Singapore)", countryCode: "SG", name: "Singapore" },
    { value: "421", label: "+421 (Slovakia)", countryCode: "SK", name: "Slovakia" },
    { value: "386", label: "+386 (Slovenia)", countryCode: "SI", name: "Slovenia" },
    { value: "677", label: "+677 (Solomon Islands)", countryCode: "SB", name: "Solomon Islands" },
    { value: "252", label: "+252 (Somalia)", countryCode: "SO", name: "Somalia" },
    { value: "27", label: "+27 (South Africa)", countryCode: "ZA", name: "South Africa" },
    { value: "34", label: "+34 (Spain)", countryCode: "ES", name: "Spain" },
    { value: "94", label: "+94 (Sri Lanka)", countryCode: "LK", name: "Sri Lanka" },
    { value: "249", label: "+249 (Sudan)", countryCode: "SD", name: "Sudan" },
    { value: "597", label: "+597 (Suriname)", countryCode: "SR", name: "Suriname" },
    { value: "46", label: "+46 (Sweden)", countryCode: "SE", name: "Sweden" },
    { value: "41", label: "+41 (Switzerland)", countryCode: "CH", name: "Switzerland" },
    { value: "963", label: "+963 (Syria)", countryCode: "SY", name: "Syria" },
    { value: "886", label: "+886 (Taiwan)", countryCode: "TW", name: "Taiwan" },
    { value: "992", label: "+992 (Tajikistan)", countryCode: "TJ", name: "Tajikistan" },
    { value: "255", label: "+255 (Tanzania)", countryCode: "TZ", name: "Tanzania" },
    { value: "66", label: "+66 (Thailand)", countryCode: "TH", name: "Thailand" },
    { value: "228", label: "+228 (Togo)", countryCode: "TG", name: "Togo" },
    { value: "676", label: "+676 (Tonga)", countryCode: "TO", name: "Tonga" },
    { value: "1-868", label: "+1-868 (Trinidad and Tobago)", countryCode: "TT", name: "Trinidad and Tobago" },
    { value: "216", label: "+216 (Tunisia)", countryCode: "TN", name: "Tunisia" },
    { value: "90", label: "+90 (Turkey)", countryCode: "TR", name: "Turkey" },
    { value: "993", label: "+993 (Turkmenistan)", countryCode: "TM", name: "Turkmenistan" },
    { value: "688", label: "+688 (Tuvalu)", countryCode: "TV", name: "Tuvalu" },
    { value: "256", label: "+256 (Uganda)", countryCode: "UG", name: "Uganda" },
    { value: "380", label: "+380 (Ukraine)", countryCode: "UA", name: "Ukraine" },
    { value: "971", label: "+971 (UAE)", countryCode: "AE", name: "UAE" },
    { value: "44", label: "+44 (UK)", countryCode: "GB", name: "UK" },
    { value: "1", label: "+1 (USA)", countryCode: "US", name: "USA" },
    { value: "598", label: "+598 (Uruguay)", countryCode: "UY", name: "Uruguay" },
    { value: "998", label: "+998 (Uzbekistan)", countryCode: "UZ", name: "Uzbekistan" },
    { value: "678", label: "+678 (Vanuatu)", countryCode: "VU", name: "Vanuatu" },
    { value: "58", label: "+58 (Venezuela)", countryCode: "VE", name: "Venezuela" },
    { value: "84", label: "+84 (Vietnam)", countryCode: "VN", name: "Vietnam" },
    { value: "681", label: "+681 (Wallis and Futuna)", countryCode: "WF", name: "Wallis and Futuna" },
    { value: "967", label: "+967 (Yemen)", countryCode: "YE", name: "Yemen" },
    { value: "260", label: "+260 (Zambia)", countryCode: "ZM", name: "Zambia" },
    { value: "263", label: "+263 (Zimbabwe)", countryCode: "ZW", name: "Zimbabwe" },
];
